/**
 * @cookie 操作方法
 * @name 变量名称
 * @value 值string
*/
import Cookies from 'js-cookie'


const getCookie = (name) => {
    return Cookies.get(name)
};
const setCookie = (name, value) => {
    return Cookies.set(name, value)
};
const removeCookie = (name) => {
    return Cookies.remove(name)
};

const cookiesFunc = {
    getCookie,
    setCookie,
    removeCookie
};

//默认，cn:中问； en：英文； 
if (cookiesFunc.getCookie('language') == undefined || cookiesFunc.getCookie('language') == '' || cookiesFunc.getCookie('language') == null) {
    cookiesFunc.setCookie('language', 'ch');
}




export default cookiesFunc;



// WEBPACK FOOTER //
// ./src/utils/jscookie.js